export default "__VITE_ASSET__Dv4oh4TV__"